
// import axios from 'axios';
import './thirddiv.css';
import IMAGES from '../../../images/images';
import { TwitterTimelineEmbed } from 'react-twitter-embed';
import { spotifyData } from '../../../data';




// console.log("auth_token>>", auth_token);

export default function ThirdDiv() {
    // const [listened, setListened] = useState([]);
 

    return (
        <div className="aboutSocial">
            <div className="aboutSocial__box1">
                <div className="aboutSocial__innerBox1">
                    {/* <img src={IMAGES.twitter_label} alt="" /> */}
                    <TwitterTimelineEmbed
                        sourceType="profile"
                        screenName="omo_t_quantum"
                        theme="dark"
                        autoHeight="true"
                        // noHeader="false"
                        noFooter="false"
                        options={{ height: 600, width: 900 }}
                    />
                </div>
            </div>
            <div className="aboutSocial__box2">
                <div className="aboutSocial__innerBox2">
                    <img className="aboutSocial__spotify" src={IMAGES.spotify_label} alt="" />
                    <div className="aboutSocial__songs">
                        <div className="aboutSocial__songsWrap">
                            {spotifyData.map(m => 
                                <a href={m.link} target='_blank' rel='noopener noreferrer'>
                                    <img src={m.img} alt="" key={m.id} />
                                </a>
                            )}         
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
